import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Button, ButtonList, DropdownButton, Page, SearchInput, } from '@dixa/lib-shared-habla';
import { useCallback, useState } from 'react';
import { useEffectOnce } from 'react-use';
import { analytics } from 'app/utils/segment';
import HoldMusicModal from 'components/powerCallFlow/components/modals/holdMusic/containers/holdMusicModal';
import { IfAgentHasRole } from 'components/shared/agentRole';
import { withPhoneNumbers, } from 'hocs/telephony';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { ExternalCallerIdModal } from '../../../containers/sections/telephony/externalCallerIdModal';
import BuyNumber from './modals/buyNumber';
import { NumberTable } from './numberTable';
var ModalType;
(function (ModalType) {
    ModalType[ModalType["BuyNumberModal"] = 0] = "BuyNumberModal";
    ModalType[ModalType["ExternalCallerModal"] = 1] = "ExternalCallerModal";
    ModalType[ModalType["HoldMusicModal"] = 2] = "HoldMusicModal";
})(ModalType || (ModalType = {}));
export const PhoneImpl = ({ phoneNumbers }) => {
    const { getItems, params } = phoneNumbers;
    const dispatch = useAppDispatch();
    const [openModalType, setOpenModalType] = useState(null);
    const handleHideModal = useCallback(() => setOpenModalType(null), []);
    const handleSearchToggle = (isOpen) => {
        if (!isOpen && params.search) {
            phoneNumbers.paramsChange({ search: null }, 0);
        }
    };
    const handleSearch = (search) => {
        analytics.phoneSearchApplied();
        if (search === params.search)
            return;
        phoneNumbers.paramsChange({ search }, 0);
    };
    useEffectOnce(() => {
        getItems();
    });
    return (_jsxs(_Fragment, { children: [_jsx(Page.Section, Object.assign({ title: "All phone numbers", controls: _jsxs(_Fragment, { children: [_jsx(SearchInput, { onToggle: handleSearchToggle, onSubmit: handleSearch }), _jsx(DropdownButton, Object.assign({ onToggle: (isOpen) => isOpen && analytics.phoneActionsMenuOpened(), dropdown: _jsxs(ButtonList, { children: [_jsx(ButtonList.Item, Object.assign({ onClick: () => {
                                            analytics.phoneActionsMenuActionAddOutboundCallerIdClicked();
                                            setOpenModalType(ModalType.ExternalCallerModal);
                                        } }, { children: "Add external caller ID" })), _jsx(ButtonList.Item, Object.assign({ onClick: () => {
                                            analytics.phoneActionsMenuActionChangeHoldMusicClicked();
                                            setOpenModalType(ModalType.HoldMusicModal);
                                        } }, { children: "Change hold music" }))] }) }, { children: "Actions" })), _jsx(IfAgentHasRole, Object.assign({ role: 'admin' }, { children: _jsx(Button, Object.assign({ variant: "primary", id: "buy-number-btn", onClick: () => {
                                    analytics.phoneFormOpened();
                                    dispatch({ type: 'TELEPHONY_BUY_NUMBER_CLICKED' });
                                    setOpenModalType(ModalType.BuyNumberModal);
                                } }, { children: "Buy number" })) }))] }) }, { children: _jsx(NumberTable, { phoneNumbers: phoneNumbers }) })), openModalType === ModalType.BuyNumberModal && (_jsx(BuyNumber, { isOpen: true, hideSearchNumberModal: handleHideModal, fetchNumbers: getItems })), openModalType === ModalType.ExternalCallerModal && (_jsx(ExternalCallerIdModal, { isOpen: true, onClose: handleHideModal })), openModalType === ModalType.HoldMusicModal && (_jsx(HoldMusicModal, { isOpen: true, onClose: handleHideModal }))] }));
};
export const Phone = withPhoneNumbers(PhoneImpl, {
    initialParams: { limit: '12' },
});
